module.exports = __webpack_public_path__ + "passport.462c3ae221cac4f0b0a9387415ff0bc6.png";